export default __webpack_public_path__ + "static/criminal-check-flow-56aad9e3724e3e1c881b720ecbea29be.svg";